import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

// const data = [
//     {
//         name: 'Feature Name',
//         desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//         img: 'https://res.cloudinary.com/doddfudab/image/upload/v1555147206/rtds_work/webmosystems/eats-in-the-west-f1.jpg'
//     },
//     {
//         name: 'Feature Name1',
//         desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//         img: 'https://res.cloudinary.com/doddfudab/image/upload/v1555219096/rtds_work/webmosystems/eats-f-2-02.png'
//     },
//     {
//         name: 'Feature Name2',
//         desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
//         img: 'https://res.cloudinary.com/doddfudab/image/upload/v1555219095/rtds_work/webmosystems/eats-f-3.png'
//     }
// ]

class FeatureContent extends Component {
    render() {
        const { data } = this.props
        return (
            <div className='feature-content'>
                {
                    data && data.map((item, index) => (
                        index%2 === 0 
                            ?   <div className='feature-item-r' key={item.id}>
                                    <div className='feature-text'>
                                        <p>{item.desc}</p>
                                    </div>
                                    <img src={item.img} alt='feature' className='feature-img'/>
                                </div>
                            :   <div className='feature-item' key={item.id}>
                                    <img src={item.img} alt='feature' className='feature-img'/>
                                    <div className='feature-text'>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                    ))
                }
            </div>
        )
    }
}

export default withRouter(FeatureContent)


// WEBPACK FOOTER //
// ./src/components/pages/category/FeatureContent.js